import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { OptionalsComponent } from '../optionals/optionals.component';
import { ItemCategoryService, ItemOutputDto, ItemService, StoreResponseDto } from 'src/generated_client';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { ConfirmDialog } from '../confirm-dialog/confirm-dialog';

@Component({
  selector: 'app-product-management',
  templateUrl: './product-management.component.html',
  styleUrls: ['./product-management.component.css']
})
export class ProductManagementComponent implements OnInit {

  displayedColumns: string[] = ['imagen', 'categoria', 'nombre', 'estado', 'statusBtn', 'banner', 'opcion'];
  allItems: ItemOutputDto[] = [];
  store: StoreResponseDto = {};

  constructor(
    public itemService: ItemService,
    public authService: AuthService,
    public itemCategoryService: ItemCategoryService,
    private dialog: MatDialog,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.store = this.authService.currentUserStore();
    this.itemService.apiItemGetAllGet(this.store.cdStore).subscribe(response => {
      this.allItems = response;
      this.allItems.sort((a, b) => (a.nmSortNo! > b.nmSortNo!) ? 1 : -1);
    })
  }
  editProduct(id: number) {
    this.router.navigate(['edit-product', id]);
  }

  addProduct() {
    this.router.navigate(['add-product']);
  }

  openDialog(isDelete: any, idItem: any, itemStatus: any, idCategory: any) {
    if (!isDelete && !itemStatus) {
      this.changeStatus(idItem, itemStatus, idCategory);
      return;
    }
    let dialogMessage: string;
    this.itemService.apiItemItemHasCartGet(idItem).subscribe(response => {
      if (response) {
        dialogMessage = 'El producto se encuentra dentro del carrito de un usuario, al realizar esta acción el producto se desaparecerá del carrito. ¿Eliminar de todos modos?'
      } else {
        dialogMessage = 'Al realizar esta acción el producto desaparecerá del menú de usuario. ¿Continuar?'
      }
      this.dialog.open(ConfirmDialog, {
        width: '30rem',
        data: {
          message: dialogMessage
        }
      }).afterClosed().subscribe((confirmado: Boolean) => {
        if (confirmado) {
          if (isDelete) {
            this.deleteProduct(idItem)
          } else {
            this.changeStatus(idItem, itemStatus, idCategory)
          }
        }
      });
    });
  }

  deleteProduct(id: number) {
    this.itemService.apiItemDeleteDelete(id).subscribe(response => {
      this.router.navigate(['product-management']);
      this.snackBar.openSnackBar('El producto fue eliminado', 'Aceptar')
    }, error => {
      this.snackBar.openSnackBar('Ocurrió un error y el producto no pudo eliminarse.', 'Aceptar')
    })
  }

  changeStatus(id: number, status: boolean, categoryId: number) {
    this.itemCategoryService.apiItemCategoryGetOneGet(categoryId).subscribe(category => {
      if (category.isEnabled) {
        this.itemService.apiItemItemStatePut(id, !status).subscribe(response => {
          this.router.navigate(['product-management']);
        }, error => {
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron realizarse.', 'Aceptar')
        });
      } else {
        this.snackBar.openSnackBar('No se puede activar el producto ya que su categoría se encuentra desactivada.', 'Aceptar')
      }
    });

  }

  addOptional(name: string, id: number, optionals: Array<number>) {
    this.dialog.open(OptionalsComponent, {
      width: '40rem',
      height: '20rem',
      data: {
        item: name,
        itemId: id,
        storeId: this.store.cdStore,
        Optionals: optionals
      }
    });
  }

  bannerChange(value: any, id: number) {
    this.itemService.apiItemEnableOrDisableItemBannerPut(id, value).subscribe(response => {
      this.router.navigate(['product-management']);
      this.snackBar.openSnackBar('Los cambios fueron guardados con éxito.', 'Aceptar');
    }, error => {
      this.snackBar.openSnackBar('Los cambios no pudieron guardarse.', 'Aceptar');
    })
  }

}
